export const ACC_ENV_KEY = 'acc';
export const TEST_ENV_KEY = 'test';
export const PROD_ENV_KEY = 'prod';
export const reqExpForReplaceProjectEnv = /acc|test/g;
export const reqExpForReplaceNumbers = /[0-9]/g;
export const localeMapping = {
    'yme-prod-al': 'en',
    'yme-prod-is': 'en',
    'yme-prod-cy': 'en',
    'yme-prod-kv': 'en',
};
export const CTA_ENDPOINT_TYPE = {
    testRide: 'testride',
    quotation: 'quotation',
};
